<app-subgrid-view
  *ngIf="subgridControl && isVisible"
  #subgridView
  [subgridParams]="subgridControl"
  [systemQuery]="systemQuery"
  [isReadOnly]="isReadOnly"
  [isDataFetchingEnabled]="isDataFetchingEnabled">
</app-subgrid-view>
